import React from "react";
import { useTranslation } from "react-i18next";

import { useDeleteDnmRoleMapping } from "~/entity/DnmRoleMappings";
import { useGetLocationData } from "~/hooks/locationData";
import { useNotify } from "~/shared/hooks/useNotify";
import { ConfirmModal } from "~/shared/ui/ConfirmModal";

interface DnmRoleMappingDeleteModalProps {
  isOpen: boolean;
  closeModal: () => void;
  reFetch: () => void;
}

const DnmRoleMappingDeleteModal = ({
  isOpen,
  closeModal,
  reFetch,
}: DnmRoleMappingDeleteModalProps) => {
  const { t } = useTranslation();
  const { remove } = useDeleteDnmRoleMapping();
  const { currentId } = useGetLocationData();
  const { notifySuccess, notifyError } = useNotify();

  const removeHandle = () => {
    const data = { id: Number(currentId) };
    remove(data, {
      onSuccess: () => {
        notifySuccess(t("dnmRoleMappings.deletedMapping"));
        reFetch();
        closeModal();
      },
      onError: (error) => {
        notifyError(error.message);
        closeModal();
      },
    });
  };

  return (
    <ConfirmModal
      open={isOpen}
      title={t("dnmRoleMappings.deleteModalTitle")}
      text={t("dnmRoleMappings.deleteModalText")}
      onConfirm={removeHandle}
      onCancel={closeModal}
    />
  );
};

export default DnmRoleMappingDeleteModal;
